import BulkActionReviewTable from "./BulkActionReviewTable";
export default BulkActionReviewTable;
